module.exports = __webpack_public_path__ + "static/media/img11.c19810cd.jpg";